<template>
    <div class="w3-col w3-left-align">
      <ContentHeader v-bind:title="$t('reports')"></ContentHeader>
    </div>

    <div class="content-sidebars sidebars-60-40">
      <SubMenus :menuItems="menuItems"></SubMenus>
    </div>
</template>

<script>
import ContentHeader from "../../common/ContentHeader";
import SubMenus from "../../common/SubMenus.vue";

export default {
  name: "Reports",
  components: { ContentHeader, SubMenus },

  data() {
    return {
      contentLoaded: false,
      menuItems: [
        {name: 'visitor-report', icon: "fas fa-list-alt", route: "visitor-report", description: "manage-reports"},
        {name: 'waiting-time-arrival-report', icon: "fas fa-list-alt", route: "waiting-times-arrival-report", description: "waiting-time-arrival-report-description"},
        {name: 'waiting-time-appointment-time-report', icon: "fas fa-list-alt", route: "waiting-times-appointment-time-report", description: "waiting-time-appointment-time-report-description"},
        {name: 'visitor-amount-report', icon: "fas fa-list-alt", route: "visitor-amount-report", description: "visitor-amount-report-description"},
        {name: 'no-show-amount-report', icon: "fas fa-list-alt", route: "no-show-amount-report", description: "no-show-amount-report-description"},
        {name: 'serving-time-report', icon: "fas fa-list-alt", route: "serving-time-report", description: "serving-time-report-description"}
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
